import { Link } from 'react-router-dom';

export default function StatsBanner() {
  const stats = [
    { value: '50万+', label: '高清视频', icon: 'ri-video-line' },
    { value: '1000万+', label: '活跃用户', icon: 'ri-user-star-line' },
    { value: '8大', label: '内容分类', icon: 'ri-stack-line' },
    { value: '99.9%', label: '播放成功率', icon: 'ri-shield-check-line' },
  ];

  return (
    <section className="py-10 md:py-14 bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20 text-background-50">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          准备好开始探索了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mb-8">
          加入千万用户的行列，在91视频网发现属于你的精彩内容世界
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/yule"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line mr-2"></i>免费开始
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:bg-background-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}